import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "body2-text text-black" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "body2-text text-black" };
const _hoisted_7 = { class: "body2-text text-black" };
const _hoisted_8 = { class: "body2-text text-black" };
const _hoisted_9 = { class: "body2-text text-black" };
const _hoisted_10 = { class: "body2-text text-black" };
const _hoisted_11 = { class: "body2-text text-black" };
const _hoisted_12 = { class: "body2-text text-black" };
import { onMounted } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import vuexStore from '@/vuex-store';
import { storeToRefs } from 'pinia';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { pStore } from '@/pinia';
import { enumTargetName, enumServiceType, } from '@/constants/baromoneyTransferSetting/baromoneytransfersettingTableHeader';
import { BusinessError } from '@/error';
import AxiosResponse from '@/error/AxiosResponse';
import { i18n } from '@/locales';
import CardSection from '@/components/Common/CardSection.vue';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import InputRow from '@/components/Form/InputRow.vue';
import { autoLcBaromoneyTransferSetting } from '@/locales/ko/views/baromoney-transfer-setting';
import SubController from './SubController.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // Page: 캐쉬이동 설정 상세보기
        const route = useRoute();
        const router = useRouter();
        const pBaromoneyTransferSetting = pStore.piniaBaromoneyTransferSetting;
        const { itemDetail, } = storeToRefs(pBaromoneyTransferSetting);
        const itemId = route.params.baromoneyTransferSettingId;
        const lc = autoLcBaromoneyTransferSetting();
        /**
         * 목록보기 클릭 핸들러
         */
        const handleClickReturnBtn = () => {
            router.push({
                name: routeName.BAROMONEY_TRANSFER_SETTING,
            }).catch(() => { });
        };
        onMounted(async () => {
            try {
                await pBaromoneyTransferSetting.getItem(itemId);
            }
            catch (error) {
                console.log('e', error);
                if (error instanceof BusinessError) {
                    if (error.status === 404) {
                        vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.invalid_access'));
                        router.go(-1);
                    }
                }
                if (error instanceof AxiosResponse) {
                    if (error.status === 404) {
                        vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.invalid_access'));
                        router.go(-1);
                    }
                }
            }
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(CardSection, null, {
                        titleContent: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(lc)('detail.sourcename_info')), 1 /* TEXT */)
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", null, [
                                _createVNode(InputRow, {
                                    label: _unref(lc)('detail.sourcename_type'),
                                    class: "brg-input-section-dense-wrapper",
                                    "wide-title": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(enumTargetName)[_unref(itemDetail).sourceType]), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createCommentVNode(" 차감대상 코드"),
                                _createVNode(InputRow, {
                                    label: _unref(lc)('detail.sourcename_code'),
                                    class: "brg-input-section-dense-wrapper",
                                    "wide-title": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(itemDetail).sourceCode), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 차감조건 정보(group)"),
                    _createVNode(CardSection, null, {
                        titleContent: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(lc)('detail.move_info')), 1 /* TEXT */)
                        ]),
                        default: _withCtx(() => [
                            _createVNode(InputRow, {
                                label: _unref(lc)('detail.movePeriodDay'),
                                class: "brg-input-section-dense-wrapper",
                                "wide-title": ""
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(itemDetail).movePeriodDayToString), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"]),
                            _createVNode(InputRow, {
                                label: _unref(lc)('detail.moveFix'),
                                class: "brg-input-section-dense-wrapper",
                                "wide-title": ""
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(itemDetail).moveFix), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"]),
                            _createVNode(InputRow, {
                                label: _unref(lc)('detail.moveRate'),
                                class: "brg-input-section-dense-wrapper",
                                "wide-title": ""
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(enumServiceType)[_unref(itemDetail).moveRateType]) + " / " + _toDisplayString(_unref(itemDetail).moveRate) + " % ( " + _toDisplayString(_unref(lc)('detail.moveTag')) + " ) ", 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"]),
                            _createVNode(InputRow, {
                                label: _unref(lc)('detail.moveMemo'),
                                class: "brg-input-section-dense-wrapper",
                                "wide-title": ""
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(itemDetail).moveMemo), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"]),
                            _createVNode(InputRow, {
                                label: _unref(lc)('detail.applyDate_expireDate'),
                                class: "brg-input-section-dense-wrapper",
                                "wide-title": ""
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(itemDetail).applyDate) + " ~ " + _toDisplayString(_unref(itemDetail).expireDate), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["label"])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 이동대상 정보(group)"),
                    _createVNode(CardSection, null, {
                        titleContent: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(lc)('detail.target_info')), 1 /* TEXT */)
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", null, [
                                _createCommentVNode(" 이동대상 구분"),
                                _createVNode(InputRow, {
                                    label: _unref(lc)('detail.target_type'),
                                    class: "brg-input-section-dense-wrapper",
                                    "wide-title": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(enumTargetName)[_unref(itemDetail).targetType]), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createCommentVNode(" 이동대상 코드"),
                                _createVNode(InputRow, {
                                    label: _unref(lc)('detail.target_code'),
                                    class: "brg-input-section-dense-wrapper",
                                    "wide-title": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(itemDetail).targetCode), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 사용여부 정보(group)"),
                    _createVNode(CardSection, null, {
                        titleContent: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(lc)('detail.use_info')), 1 /* TEXT */)
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", null, [
                                _createCommentVNode(" 사용여부 "),
                                _createVNode(InputRow, {
                                    label: _unref(lc)('detail.use'),
                                    class: "brg-input-section-dense-wrapper",
                                    "wide-title": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(itemDetail).isDeletedToString), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createVNode(BoardFooter, null, {
                    left: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode(" mdi-chevron-left ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [0]
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.back_to_list')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ])
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
